<template>
  <div>
    <section class="p-box">
      <div class="p-box__body">
        <Loading v-show="store_gmb_infos_loading" />
        <template v-if="store_gmb_infos && !store_gmb_infos_loading">
          <div class="c-grid">
            <div class="c-grid__items">
              <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__8 c-grid__item__l__8">
                <section class="p-box">
                  <div class="p-box__body">
                    <h3 class="c-pageTitle">カテゴリ</h3>
                    <div class="p-formGrid">
                      <div class="p-formGrid__items">
                        <fieldset class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                          <label for="" class="c-formLabel">メインカテゴリ</label>
                          <input v-model="mainCategory.name" type="text" class="c-textField" placeholder="設定されていません">
                        </fieldset>
                        <fieldset v-for="(sub, index) in subCategories" :key="index" class="p-formGrid__item p-formGrid__item__s__12 p-formGrid__item__m__12 p-formGrid__item__l__12">
                          <label for="" class="c-formLabel">追加カテゴリ</label>
                          <input v-model="sub.name" type="text" class="c-textField" placeholder="例) 1234567">
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </section>
                <section class="p-box">
                  <div class="p-box__body">
                    <h3 class="c-pageTitle">特徴</h3>
                    <ul class="c-checkbox">
                      <li v-for="(feature, index) in featureValues" :key="index" class="c-checkbox__item c-checkbox__item__s__6">
                        <input
                          :id="`feature_${index}`"
                          v-model="selectedFeatures"
                          :value="{'kind': 'feature', name: feature.name}"
                          type="checkbox"
                          class="c-checkbox__input"
                        >
                        <label
                          class="c-checkbox__label"
                          :for="`feature_${index}`"
                          v-text="feature.name"
                        />
                      </li>
                    </ul>
                  </div>
                </section>
                <section class="p-box">
                  <div class="p-box__body">
                    <h3 class="c-pageTitle">サービスオプション</h3>
                    <ul class="c-checkbox">
                      <li v-for="(service_option, index) in serviceOptionValues" :key="index" class="c-checkbox__item c-checkbox__item__s__6">
                        <input
                          :id="`service_option_${index}`"
                          v-model="selectedServiceOptions"
                          :value="{'kind': 'service_option', name: service_option.name}"
                          type="checkbox"
                          class="c-checkbox__input"
                        >
                        <label
                          class="c-checkbox__label"
                          :for="`service_option_${index}`"
                          v-text="service_option.name"
                        />
                      </li>
                    </ul>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </template>
      </div>
      <footer class="p-box__footer">
        <div class="c-button c-button--right">
          <router-link :to="{ name: 'CompaniesLocationStore', params: { company_uuid: companyUuid, store_uuid: storeUuid }}" class="c-button__item c-button__item--outline-cancel">
            キャンセル
          </router-link>
          <button class="c-button__item c-button__item--primary" @click="handleSubmit()">
            保存する
          </button>
        </div>
      </footer>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Loading from '../components/Loading.vue'

export default {
  name: 'CompaniesLocationStoreGmbInfosEdit',
  components: {
    Loading,
  },
  data () {
    return {
      companyUuid: this.$route.params.company_uuid,
      storeUuid: this.$route.params.store_uuid,
      // TODO GMBより取得予定の値なので仮置き
      featureValues: [
        { name: 'スポーツ' },
        { name: 'テラス席がある' },
        { name: '女性経営者' },
        { name: '星上の席あり' },
        { name: '暖炉がある' },
        { name: '生演奏がある' },
        { name: '飲み放題' },
      ],
      // TODO GMBより取得予定の値なので仮置き
      serviceOptionValues: [
        { name: 'イートイン' },
        { name: 'テイクアウト' },
        { name: 'ドライブスルー' },
        { name: '宅配' },
        { name: '店先受け取り可' },
        { name: '非接触デリバリー' },
      ],
    }
  },
  computed: {
    ...mapState({
      store_gmb_infos: state => state.companiesStoreGmbInfos.data,
      store_gmb_infos_loading: state => state.companiesStoreGmbInfos.loading,
      mainCategory: state => state.companiesStoreGmbInfos.mainCategory,
      subCategories: state => state.companiesStoreGmbInfos.subCategories,
      features: state => state.companiesStoreGmbInfos.features,
      serviceOptions: state => state.companiesStoreGmbInfos.serviceOptions,
    }),
    selectedMainCategory: {
      get: function() {
        return this.mainCategory
      },
      set: function(val) {
        this.setMainCategory(val)
      },
    },
    selectedSubCategories: {
      get: function() {
        return this.subCategories
      },
      set: function(val) {
        this.setSubCategories(val)
      },
    },
    selectedFeatures: {
      get: function() {
        return this.features
      },
      set: function(val) {
        this.setFeatures(val)
      },
    },
    selectedServiceOptions: {
      get: function() {
        return this.serviceOptions
      },
      set: function(val) {
        this.setServiceOptions(val)
      },
    },
  },
  created: function () {
    if (!this.store_gmb_infos) {
      this.readStoreGmbInfos({ company_uuid: this.companyUuid, store_uuid: this.storeUuid })
    }
  },
  methods: {
    ...mapActions({
      readStoreGmbInfos: 'companiesStoreGmbInfos/readStoreGmbInfos',
      updateStoreGmbInfos: 'companiesStoreGmbInfos/updateStoreGmbInfos',
      setFeatures: 'companiesStoreGmbInfos/setFeatures'
    }),
    handleSubmit: function () {
      // TODO GMB連携時に開放
      // this.updateStoreGmbInfos({ company_uuid: this.companyUuid, store_uuid: this.storeUuid, store_gmb_infos: this.store_gmb_infos })
    }
  }
}
</script>
